import { signApiGatewayRequest } from '../../components/utils/amplifyAuthHelpers';

const createSignedRequest = async (method, endpoint, data = '', headers = {}) => {
  let resolvedEndpoint = endpoint;

  // For Local Testing
  if (process.env.REACT_APP_LOCAL_BACK_TEST) {
    const splitEndpoint = endpoint.split(':3001')[1];
    if (['/payment'].some((x) => endpoint.includes(x))) {
      resolvedEndpoint = `http://localhost:3002${splitEndpoint}`;
    } else if (['/registration', '/authentication'].some((x) => endpoint.includes(x))) {
      resolvedEndpoint = `http://localhost:3003${splitEndpoint}`;
    } else {
      resolvedEndpoint = `http://localhost:3001${splitEndpoint}`;
    }
  }

  return signApiGatewayRequest(method, resolvedEndpoint, data, headers);
};

export default createSignedRequest;
